import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';
import './styles/properties.css';
import './styles/pricing.css';
import './styles/specs.css';
import './styles/media.css';
import './styles/public.css';
import './styles/calendar.css';
import './styles/inquiries.css';
import './styles/opportunities.css';
import './styles/skins.css';
import './i18n';
import { App } from './app/App';
import { AuthProvider } from './features/auth/AuthProvider';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
